<template>
  <div class="row justify-content-center">
    <template class="consolidatedErrors_modal">
      <a-modal v-model="isModalVisible" :maskClosable="false" :closable="false" title="Incomplete Configuration" centered>
        <template slot="footer">
          <a-button key="submit" type="primary" @click="closeModal">
            Ok
          </a-button>
        </template>
        <div>
          <p v-for="e in consolidatedErrors" :key="e.description" class="consolidatedErrors_description">
            {{ _.upperCase(e.description) }} ({{ e.errors.length }})
          <ul>
            <li v-for="error in e.errors" :key="`${error + Math.random()}`" class="consolidatedErrors_errors_list">
              {{ _.startCase(error) }} is not properly configured</li>
          </ul>
          </p>
        </div>
      </a-modal>
    </template>
    <div class="col-lg-5 col-md-7">
      <div v-if="errorMessage != null" id="errorNotification">
        <base-alert type="danger">
          <span class="alert-inner--text"> {{ errorMessage }}</span> <br>
          <span v-if="canClearExistingSession == true">Click <a @click="clearExistingSession"><u>here</u></a> to remove
            existing session</span>
          <!-- <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                           <span aria-hidden="true">&times;</span>
                        </button> -->
        </base-alert>
      </div>
      <div v-else-if="successMessage != null">
        <base-alert type="success">
          <span class="alert-inner--text"> {{ successMessage }}</span> <br>
        </base-alert>
      </div>
      <div class="card bg-secondary shadow border-0">
        <div class="card-body px-lg-5 py-lg-5">
          <h1>{{showOTP ? 'Enter OTP' : 'Log in'}}</h1> 
          <span v-show="showOTP">
            Check your email for the OTP.
          </span>
          <br>
          <form role= "form" v-if="showOTP" class="pt-5">
            <base-input class="input-group-alternative mb-3" placeholder="Enter OTP" addon-left-icon="ni ni-building"
              v-model="loginCode">
            </base-input>
            <div class="text-cemter">
              <div class="my-3 d-flex justify-content-center">
                <base-button type="primary" class="my-4" @click.prevent="validateLoginCode" style="width: 50%;"
                  :disabled="validatingLoginCode">
                  <a-spin v-if="validatingLoginCode" :spinning="validatingLoginCode" />
                  <div v-else>Verify</div>
                </base-button>
                <base-button type="default" :disabled="timerEnabled" @click="resendLoginCode" class="my-4" style="width: 50%;">
                  <div>Resend Code <span v-show="timerEnabled">({{ timerCount }})</span></div>
                </base-button>
              </div>
            </div>
          </form>
          <form role="form" v-else>
            <base-input class="input-group-alternative mb-3" placeholder="Account Name" addon-left-icon="ni ni-building"
            data-testid="login-account" id="login-account" v-model="accountName">
            </base-input>

            <base-input class="input-group-alternative mb-3" placeholder="Username/Email"
            data-testid="login-input-username" id="login-input-username" addon-left-icon="ni ni-email-83" v-model="email">
            </base-input>

            <div class="form-group input-group-alternative mb-3 input-group"><!---->
              <div class="input-group-prepend">
                <span class="input-group-text"><i class="ni ni-lock-circle-open"></i></span>
              </div>
              <input aria-describedby="addon-right addon-left" placeholder="Password" data-testid="login-input-password" id="login-input-password" :type="defaultPasswordType" class="form-control" v-model="password" @keyup.enter="authenticateUser"><!----><!---->
              <div class="input-group-prepend">
                <a class="input-group-text" @click="changePasswordType">
                  <span v-if="defaultPasswordType == 'password'" style="color: #adb5bd;"><i class="fas fa-eye"></i></span>
                  <span v-else style="color: #adb5bd;"><i class="fa fa-eye-slash"></i></span>
                </a>
              </div>
            </div>

            <!-- <base-input class="input-group-alternative mb-3" @keyup.enter="authenticateUser" placeholder="Password"
            data-testid="login-input-password" id="login-input-password" type="password" addon-left-icon="ni ni-lock-circle-open" v-model="password">
            </base-input> -->
            <div v-show="showReCaptcha">
              <div id="recaptchaContainer" class="g-recaptcha" data-sitekey="6Lfx27EmAAAAAFKJgVjC2Kwt83cxbsJsY_WDV324"></div>
            </div>

            <div class="text-center">
              <div class="my-3 d-flex justify-content-center">
                <base-button type="primary" class="my-4" data-testid="login-btn-signin" id="login-btn-signin" @click.prevent="authenticateUser" style="width: 50%;"
                  :disabled="loggingIn">
                  <a-spin v-if="loggingIn" :spinning="loggingIn" />
                  <div v-else>Sign in</div>
                </base-button>
                <base-button type="warning" @click="timeEntry" class="my-4" style="width: 50%;">
                  <div>Time Entry</div>
                </base-button>
              </div>
              <br>
              <a @click="forgotPassword"  data-testid="login-btn-forgot-pw" id="login-btn-forgot-pw" class="text-dark"><small>Forgot password?</small></a>
              <br>
              <small>Don't have an account? </small>
              <a @click="signUp" data-testid="login-btn-signup" id="login-btn-signup" class="text-dark"><small class="signUpText">Sign up</small></a>
              <br>
              <small class="text-blue">Version 1.3.14.0 </small>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HTTPRequest from '../controllers/httpRequest.js'
import secureStorage from '../controllers/secureStorage.js'
import { mapState, mapActions } from 'vuex'
import axios from "axios";


import Fingerprint2 from 'fingerprintjs2'

var options = {}
var browserId = ""

// import axios from "axios";
var navigate, component_x;
export default {
  computed: {
    ...mapState(['loggedIn', 'endPoint', 'userEmail']),
  },
  created: async function () {
    secureStorage.setItem("default_logo", this.default_logo);
    navigate = this.$router;
    component_x = this;
    secureStorage.setItem("developerMode", false);
    if (window.requestIdleCallback) {
      await requestIdleCallback(function () {
        Fingerprint2.get(options, async function (components) {
          var values = components.map(function (component) { return component.value })
          var murmur = Fingerprint2.x64hash128(values.join(''), 31)
          browserId = murmur
          var autoLogin = await HTTPRequest.getRequest(component_x.endPoint + 'backend_sessions/auto_login?machine_id=' + browserId, null, null)
          secureStorage.setItem("autoLogin", autoLogin.status);
          let serverRunning = secureStorage.getItem("serverRunning")
          if (serverRunning == false) {
            navigate.push({ name: "server_maintenance" });
          }
          
          if (autoLogin.status == true && secureStorage.getItem("loggedIn") == true) {
            if (component_x.accountName != "ripple") {
              let logoSettings = await HTTPRequest.getRequest(this.endPoint + 'settings?code=account_logo', null)
              if (logoSettings.length > 0 && logoSettings[0]["value"] != null && logoSettings[0]["value"] != '') {
                secureStorage.setItem("account_logo", logoSettings[0]["value"]);
              } else {
                secureStorage.setItem("account_logo", this.default_logo);
              }
              navigate.push({name: 'landing_page'});
            } else {
              secureStorage.setItem("account_logo", this.default_logo);
              secureStorage.setItem("accountTemplateName", "Internal");
              navigate.push('dashboard');
            }

            // navigate.push({name: 'landing_page'});
            component_x.$notification['info']({
              message: 'Welcome to BXI',
              description: "You still have an active session for this device."
            });
          }
        })
      })
    }
  },
  mounted: async function() {
    component_x = this;
    this.loadReCaptchaScript();
    if (secureStorage.getItem("loggedIn") == true && secureStorage.getItem("autoLogin") == true) {
      if (component_x.accountName != "ripple") {
        let logoSettings = await HTTPRequest.getRequest(this.endPoint + 'settings?code=account_logo', null)
        if (logoSettings.length > 0 && logoSettings[0]["value"] != null && logoSettings[0]["value"] != '') {
          secureStorage.setItem("account_logo", logoSettings[0]["value"]);
        } else {
          secureStorage.setItem("account_logo", this.default_logo);
        }
        navigate.push('/landing_page');
      } else {
        secureStorage.setItem("account_logo", this.default_logo);
      }
    }
  },
  data: function () {
    return {
      isModalVisible: false,
      consolidatedErrors: [],
      default_logo: "https://bxi-upload-bucket.s3.ap-southeast-1.amazonaws.com/iripple-images/accounts/irippledemo/1657239408099_070822081646-62-logo2.png",
      email: '',
      password: '',
      accountName: '',
      errorMessage: null,
      successMessage: null,
      loggingIn: false,
      canClearExistingSession: false,
      clearUsername: '',
      clearAccountName: '',
      businessTypeCode: '',
      recaptchaVerified: false,
      showReCaptcha: false,
      showOTP:false,
      validatingLoginCode:false,
      loginCode:'',
      timerEnabled: false,
      timerCount: 30,
      existingMachineId:null,
      checkAccountId:0,
      defaultPasswordType:"password"
    }
  },

  methods: {
    ...mapActions(['updateLoggedInStatus', 'updateUserEmail', 'updateDefaultSite']),
    loadReCaptchaScript() {
      const script = document.createElement("script");
      script.src = "https://www.google.com/recaptcha/api.js";
      script.async = true;
      script.defer = true;
      script.onload = this.initReCaptcha; // Call the initReCaptcha function after the script is loaded
      document.head.appendChild(script);
    },

    initReCaptcha() {
      // Initialize the reCAPTCHA widget and add an event listener
      const recaptchaContainer = document.getElementById("recaptchaContainer");
      if (recaptchaContainer) {
        grecaptcha.render(recaptchaContainer, {
          sitekey: "6Ld3d7cmAAAAALoZ9E1DjEstSmAYGoetWknCdwuK",
          callback: this.onRecaptchaVerified, // Call the onRecaptchaVerified function when reCAPTCHA is verified
        });
      }
    },
    onRecaptchaVerified(response) {
      this.recaptchaVerified = !!response;
    },
    closeModal() {
      this.isModalVisible = false
      this.consolidatedErrors = []
      navigate.push({name: 'landing_page'});
    },
    forgotPassword() {
      this.$router.push("password_reset")
    },
    timeEntry() {
      this.$router.push("time_entry")
    },
    signUp() {
      this.$router.push("signup_now")
    },
    async clearExistingSession() {
      var post_request = await HTTPRequest.postRequest(this.endPoint + 'backend_sessions/delete_existing_session?email=' + this.clearUsername + '&account=' + this.clearAccountName, null, null, false)
      if (post_request.status == true) {
        this.errorMessage = null
        this.successMessage = 'You have successfully cleared your existing session, please login again.'
      } else {
        this.errorMessage = "Error clearing existing session"
        this.successMessage = null
      }
    },
    logOut() {
      var id = secureStorage.getItem("sessionId")
      axios({
        method: 'delete',
        url: this.endPoint + '/backend_sessions/' + id,
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
        },
      })
        .then(function () {
          component_x.updateLoggedInStatus(false);
          secureStorage.setItem("loggedIn", false)
          navigate.push('/');
        })
        .catch(function () {
          alert("Invalid Credentials")
        });
    },
    authTokenRequest: async function () {
      var md5 = require('md5'); 
      secureStorage.setItem("accessToken", null);
      secureStorage.setItem("refreshToken", null);
      let request = await HTTPRequest.postRequest(this.endPoint.split("/api")[0] + '/oauth/token', null, { account_name: this.accountName, email: this.email, password: md5(this.password), grant_type: "password" })
      if (request["error"] == undefined) {
        secureStorage.setItem("accessToken", request["access_token"]);
        secureStorage.setItem("refreshToken", request["refresh_token"]);
      }

      return request;
    },
    authenticateUser: async function () {
      this.loggingIn = true
      if (this.email == null || this.password == null || this.email == '' || this.password == '') {
        component_x.errorMessage = "Email and password are both required fields for login."
        this.loggingIn = false;
      } else if (this.showReCaptcha && !this.recaptchaVerified) {
        component_x.errorMessage = "reCAPTCHA verification failed"
        this.loggingIn = false;
      }else {
        var passwordResetPayload = { email: this.email, account_name: this.accountName }
        var post_request = await HTTPRequest.postRequest(this.endPoint + 'users/validate', null, passwordResetPayload, true)
        if (post_request["error"] != undefined) {
          // alert("It seems you entered a wrong username/email address. Please try again.")
          this.errorMessage = "Invalid login credentials. Please check your account name, username or password."
          this.showReCaptcha = true
          this.loggingIn = false;
        } else {
          var invalid_attempts = post_request["success"][0]["invalid_attempts"] + 1
          let expired_at = post_request["success"][0]["expired_at"]
          secureStorage.setItem("userId", post_request["success"][0]["id"])
          this.existingMachineId = post_request["success"][0]["machine_id"]
          this.checkAccountId = post_request["success"][0]["account_id"]
          let is_expired = false
          let status = post_request["success"][0]["status"]
          if (expired_at != null) {
            let date1 = new Date(expired_at)
            let date2 = new Date()
            if (date1 <= date2) {
              is_expired = true
            }
          }

          var err_message = "It seems you've entered a wrong password. Please try again. (Invalid Attempts: " + invalid_attempts + ")"
          post_request = {}
          if (status == "I") {
            post_request["error"] = "User is deactivated. Please contact your administrator."
            err_message = post_request["error"]
          } else if (invalid_attempts > 4) {
            post_request = await this.authTokenRequest();
            if (post_request["error"]) {
              post_request["error"] = "User locked because of three invalid attempts. Please contact your administrator."
              err_message = post_request["error"]
            } else post_request = {};
          } else if (is_expired == true) {
            post_request["error"] = "It seems you've entered a expired user. Please contact your administrator."
            err_message = post_request["error"]
          } else {
            var bodyFormData = new FormData();
            bodyFormData.set('email', this.email);
            bodyFormData.append('password', this.password);
            bodyFormData.append('account_name', this.accountName);
            bodyFormData.append('grant_type', 'password');
            var access_token = secureStorage.getItem("refreshToken")
            if (access_token == undefined) {
              post_request = await this.authTokenRequest();
            }
            var userName = secureStorage.getItem("userName")
            var email = secureStorage.getItem("email")
            if (this.email == userName || this.email == email) {
              var check_password = await HTTPRequest.postRequest(this.endPoint + "/users/validate_password", null, { account_name: this.accountName, email: this.email, password: this.password }, true)
              if (check_password["error"] == undefined) {
                post_request = { success: "Password okay" }
                secureStorage.setItem("userId", check_password["user_id"])
              }
              else {
                this.errorMessage = "Invalid login credentials. Please check your account name, username or password."
                post_request = { error: "Invalid password" }
                this.showReCaptcha = true
                this.loggingIn = false;
              }
            } else {
              post_request = await this.authTokenRequest();
            }
          }

          if (post_request["error"] == undefined) {
            if(['ripple'].includes(this.accountName) || this.checkAccountId == -1 || this.existingMachineId == browserId){
              await this.afterLoginFunction();
              await this.getBusinessType();
            }else{
              var response = await this.sendLoginCode();
              if (response["error"] == undefined){
                this.showOTP = true
              }
            }
            // show OTP UI
          } else {
            component_x.errorMessage = err_message
            secureStorage.removeItem("accessToken");
            secureStorage.removeItem("refreshToken");
            this.showReCaptcha = true
            this.showOTP = false
            this.loggingIn = false;
          }

        }

      }
      this.loggingIn = false
    },
    validateLoginCode: async function(){
      this.validatingLoginCode = true
      var validate_login_code = await HTTPRequest.postRequest(this.endPoint + '/users/validate_login_code', null, {login_code:this.loginCode,user_id:secureStorage.getItem("userId"),machine_id:browserId})
      if (validate_login_code["error"] == undefined){
        await this.afterLoginFunction()
      } else {
        this.errorMessage = "Invalid OTP."
      }
      await this.getBusinessType();
      this.validatingLoginCode = false
    },
    afterLoginFunction: async function(){
      let ip_params = ""
      let ip = ""
      await axios({
        method: 'get',
        url: '//api.ipify.org?format=json',
      })
        .then(function (response) {
          if (response.data != null) {
            // console.log(response.data.ip)
            ip = response.data.ip
            ip_params = "&ip_address=" + response.data.ip
          }
        })
        .catch(function () {
          console.log("Network Error on IPIFY");
        });
        secureStorage.setItem("ipAddress",ip)
      // console.log(ip_params);
      var createSession = await HTTPRequest.postRequest(this.endPoint + 'backend_sessions?machine_id=' + browserId + ip_params, null, null)
      if (createSession["error"] != undefined) {
        component_x.errorMessage = createSession["error"]
        if (component_x.errorMessage == 'You still have an active session. Please logout.') {
          component_x.canClearExistingSession = true
          component_x.clearUsername = this.email
          component_x.clearAccountName = this.accountName
          this.loggingIn = false;
        } else {
          component_x.canClearExistingSession = false
          component_x.clearUsername = ''
          component_x.clearAccountName = ''
        }
      } else {
        component_x.clearUsername = ''
        component_x.clearAccountName = ''
        secureStorage.setItem("sessionId", createSession["id"])
        secureStorage.setItem("accountName", component_x.accountName)
        secureStorage.setItem("accountCompanyName", createSession["account_company_name"])
        secureStorage.setItem("userName", createSession["name"])
        secureStorage.setItem("isAccountOwner", createSession["is_account_owner"])
        secureStorage.setItem("userId", createSession["user_id"])
        if(createSession["password_expiration"]!=undefined) secureStorage.setItem("passwordExpiration", createSession["password_expiration"])
        secureStorage.setItem("accountId", createSession["account_id"])
        secureStorage.setItem("defaultSiteId", createSession["default_site_id"])
        secureStorage.setItem("defaultSiteConceptId", createSession["default_site_concept_id"])
        secureStorage.setItem("defaultSiteName", createSession["default_site_name"])
        secureStorage.setItem("defaultSiteCode", createSession["default_site_code"])
        secureStorage.setItem("defaultSiteSBU", createSession["default_site_sbu"])
        secureStorage.setItem("isRequireChangePw", createSession["is_require_changepw"])
        secureStorage.setItem("userCode", createSession["user_name"])
        secureStorage.setItem("email", createSession["name"])
        secureStorage.setItem("isRippleAdmin", createSession["is_admin"])
        secureStorage.setItem("loggedIn", true)
        component_x.updateUserEmail(createSession["name"])
        component_x.updateLoggedInStatus(true)

        //Get alerts/reminders & put in secure storage
        if (component_x.accountName != "ripple") {
        var user_alerts = await HTTPRequest.getRequest(this.endPoint + 'settings/get_user_alerts?userId=' + secureStorage.getItem("userId") + '&defaultSiteId=' + secureStorage.getItem("defaultSiteId") + '', null)
        secureStorage.setItem("userAlerts", ((user_alerts.length > 0) ? JSON.parse(user_alerts[0].system_alert_id) : []))

        //Get user sites
        var userSites = await HTTPRequest.getRequest(this.endPoint + '/users/' + secureStorage.getItem("userId")  + '/valid_sites', null, null)
        secureStorage.setItem("userSites", ((userSites.length > 0) ? userSites : []))

        
          let logoSettings = await HTTPRequest.getRequest(this.endPoint + 'settings?code=account_logo', null)
          if (logoSettings.length > 0 && logoSettings[0]["value"] != null && logoSettings[0]["value"] != '') {
            secureStorage.setItem("account_logo", logoSettings[0]["value"]);
          } else {
            secureStorage.setItem("account_logo", this.default_logo);
          }
        } else {
          secureStorage.setItem("account_logo", this.default_logo);
        }

        if (component_x.accountName != "ripple") {
          // Checks if the required fields are properly configured
          // START
          await HTTPRequest.getRequest(this.endPoint + "check_configurations/check_account_configurations", null).then(
            (resp) => {
              resp.forEach((err, idx) => {
                if (err.errors.length > 0) {
                  if (idx > 1) {
                    err.description += ` template`
                    this.consolidatedErrors.push(err)
                  } else {
                    this.consolidatedErrors.push(err)
                  }
                }
              })
            }
          );
          // END

          if (createSession["terms_url"] == null || createSession["privacy_url"] == null) {
            this.$notification['warning']({
              message: 'Missing DPC documents',
              description: "Please make sure to provide the required documents for DPC compliance."
            });
          }
          secureStorage.setItem("termsUrl", createSession["terms_url"])
          secureStorage.setItem("privacyUrl", createSession["privacy_url"])
        }

        var site = await HTTPRequest.getRequest(this.endPoint + 'sites/' + createSession["default_site_id"], null)
        if (site.id > 0) {
          secureStorage.setItem("currentSiteSiteType", site.site_type)
        }
        if (this.consolidatedErrors.length > 0) {
          this.isModalVisible = true
        } else {
          if (component_x.accountName != "ripple"){
            navigate.push({name: 'landing_page'});
          } else{
            navigate.push('dashboard');
          }
        }
      }
    },
    getBusinessType: async function(){
      // get account business type of the account
      if (component_x.accountName != 'ripple'){
        var userId = secureStorage.getItem("userId")
        var account_business_type = await HTTPRequest.getRequest(this.endPoint + '/users/get_account_business_type?user_id=' + userId, null)
        secureStorage.setItem("accountTemplateName", account_business_type.account_template_name);
        if (account_business_type.code == 'CST' || account_business_type.code == 'OTH'){
          this.businessTypeCode = 'SUP'
        } else {
        this.businessTypeCode = account_business_type.code;
        }
        localStorage.setItem("businessTypeCode", JSON.stringify(this.businessTypeCode));
      } else {
        secureStorage.setItem("accountTemplateName", "Internal");
      }
    },
    sendLoginCode: async function(){
      var send_login_code = await HTTPRequest.postRequest(this.endPoint + '/users/send_login_code', null, {account_name:this.accountName,user_id:secureStorage.getItem("userId")})
      return send_login_code
    },
    resendLoginCode: async function(){
      var response = await this.sendLoginCode();
      if (response["error"] == undefined){
        this.timerCount = 60;
        this.timerEnabled = true;
        this.countDownTimer();
      }
    },
    countDownTimer () {
      if (this.timerCount > 0 && this.timerEnabled) {
          setTimeout(() => {
              this.timerCount -= 1
              this.countDownTimer()
          }, 1000)
      } else {
        this.timerEnabled = false
      }
    },
    changePasswordType(){
      if(this.defaultPasswordType=="password"){
        this.defaultPasswordType = "text"
      }else{
        this.defaultPasswordType = "password"
      }
    }
  },
}
</script>

<style>
/* .consolidatedErrors_modal{
  height: 100vh !important;
} */
.consolidatedErrors_description {
  font-size: 14px !important;
  font-weight: bold;
  line-height: 1rem !important;
}

.consolidatedErrors_errors_list {
  font-weight: normal;
   line-height: 1.1rem !important;
}
.signUpText{
 color: #2dce89;
}
</style>
